export const RequiredBadge: React.FC = () => {
  return (
    <span className="bg-[#D19C9A] text-white font-semibold px-1.5 py-0.5 rounded text-[10px]">
      必須
    </span>
  );
};
